import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { clearFormError, removeFieldError } from 'lib/src/redux/actions/fieldErrors';

export default function useForm<TForm>(initialData: TForm): UseForm<TForm> {
    const dispatch = useDispatch();
    const [formData, setFormData] = useState<TForm>(initialData);

    function handleChange<T>(name: string, value: T) {
        setFormData((prev: TForm) => ({ ...prev, [name]: value }));
    }

    function initForm() {
        // clear out generic form errors and field error
        dispatch(clearFormError());
        // @ts-ignore
        Object.keys(formData).forEach(key => dispatch(removeFieldError(key)));
    }

    function resetData(data: TForm) {
        setFormData(data);
    }

    return [formData, handleChange, resetData, initForm];
}

type UseForm<TForm> = [
    formData: TForm,
    handleChange: <T>(name: string, value: T) => void,
    resetData: (data: TForm) => void,
    initForm: () => void,
];
